const initialState = {
    isReadingUsers: false,
    users: [],
    count: 0
}

export default initialState;
